import { ApolloError } from "@apollo/client";

const getErrors = (error: ApolloError | undefined): string[] | undefined => {
  return error?.graphQLErrors.map(({ message }) => message);
};

export { getErrors };
